module.exports = __webpack_public_path__ + "img/professor.3c1d1274.jpg";